module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/driveUpFeatured1.webp";